// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3e41ebd2","977":"11058052"}[chunkId] + ".chunk.js";
};